<template>
<v-app>
    <v-container fluid class="mt-1">
        <v-row>
            <v-col cols="3">
                <v-card>
                    <v-card-title>
                        <v-btn @click="goToVivalis()" class="mb-4" color="primary" block=true>Voir les offres Vivalis</v-btn>
                        Simulateur Crédit
                    </v-card-title>
                    <v-card-text>
                        <FormSimulateurCredit :tarif="tarif" :index="index" :periodeId="periodeId" type="BMCI"></FormSimulateurCredit>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col>
                <v-carousel hide-delimiter-background height="auto" show-arrows-on-hover v-model="index">
                    <v-carousel-item>
                        <LoaBMCISubventionnes></LoaBMCISubventionnes>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaBmciTx0Particuliers></LoaBmciTx0Particuliers>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaBmciTx0Societes></LoaBmciTx0Societes>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaBMCIParticuliers></LoaBMCIParticuliers>
                    </v-carousel-item>
                    <v-carousel-item>
                        <LoaBMCISocietes></LoaBMCISocietes>
                    </v-carousel-item>
                    <v-carousel-item>
                        <CreditParticulers></CreditParticulers>
                    </v-carousel-item>
                    <v-carousel-item>
                        <CreditBMCISocietes></CreditBMCISocietes>
                    </v-carousel-item>
                </v-carousel>
            </v-col>
        </v-row>

    </v-container>
</v-app>
</template>

<script>
import CreditParticulers from './creditParticuliers.vue'
import CreditBMCISocietes from './creditSocietes.vue'
import LoaBMCISubventionnes from './loaSubventionnes.vue'
import LoaBmciTx0Particuliers from './loaTx0Particuliers.vue'
import LoaBmciTx0Societes from './loaTx0Societes.vue'
import LoaBMCIParticuliers from './loaParticuliers.vue'
import LoaBMCISocietes from './loaSocietes.vue'
import FormSimulateurCredit from './../formSimulateur.vue'
export default {
    name: "BmciAccueil",
    data() {
        return {
            index: 0
        }
    },
    props: ["tarif", "periodeId"],
    mounted() {},
    methods: {
      goToVivalis: function () {
        this.$router.push({
          name: "VivalisAccueil",
          params: {
            tarif: this.tarif,
            periodeId: this.periodeId
          }
        })
      }
    },
    components: {
        CreditParticulers,
        CreditBMCISocietes,
        LoaBMCISubventionnes,
        LoaBmciTx0Particuliers,
        LoaBmciTx0Societes,
        LoaBMCISocietes,
        LoaBMCIParticuliers,
        FormSimulateurCredit
    }
}
</script>
